import React, { useContext, useEffect, useRef, useState } from "react";
import { VendorContext } from "../../../../../context/vendor/VendorContext";
import { CssTextField, ButtonUpload } from "../../style";
import { Button, Container, Column, ColumnButtons, Tittle } from "../style";
import { OptionSelect, CssNativeSelect } from "./style";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { FormControl, InputLabel } from "@mui/material";
import Wait from "../../../../Wait";
import { useTranslation } from "react-i18next";
import { AlertSpan } from "../step3/style";
import { ErrorOutline } from "@mui/icons-material";

const documents = [
  {
    id: 1,
    name: "bankCertificate",
  },
];
const typeAccount = [
  {
    id: 0,
    name: "CUENTA CORRIENTE",
  },
  {
    id: 1,
    name: "CUENTA DE AHORROS",
  },
];
const typeIdentification = [
  {
    id: "R",
    name: "Ruc",
  },
  {
    id: "C",
    name: "Cédula",
  },
  {
    id: "P",
    name: "Pasaporte",
  },
];
const Step2 = () => {
  const { t } = useTranslation();
  const [nonNumber, setNonNumber] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const {
    steps,
    activeStep,
    vendorInformation,
    vendDocumentation,
    vendBankAccount,
    contactPersonBank,
    vendFlowEnrollment,
    logisticsPostalAddress,
    listProvince,
    listTypeContact,
    listCity,
    listBank,
    setActiveStep,
    getListProvince,
    getListCity,
    getListBank,
    getVendBankAccount,
    getBase64,
    sendLogisticsPostalAddress,
    sendVendDocumentation,
    sendVendBankAccount,
    sendContactPerson,
    sendVendFlowEnrollment,
  } = useContext(VendorContext);
  const uploadCertificadoBancario = useRef(null);
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleUpload = (e, tag) => {
    e.preventDefault();
    console.log(tag);
    if (tag === 1) {
      uploadCertificadoBancario.current.click();
    }
  };
  const handleFileUpload = (event) => {
    const fileUploaded = event.target.files[0];
    getBase64(fileUploaded)
      .then((data) => {
        vendDocumentation[event.target.name] = data;
        sendVendDocumentation(vendDocumentation);
      })
      .catch((error) => {
        alert("Error: " + error.currentTarget.error);
      });
  };
  const handleInformation = (event, tag) => {
    event.preventDefault();
    vendBankAccount[event.target.name] = event.target.value;
    sendVendBankAccount(vendBankAccount);
  };
  const handleLogisticsAddressInformation = (event) => {
    event.preventDefault();
    logisticsPostalAddress[event.target.name] = event.target.value;
    sendLogisticsPostalAddress(logisticsPostalAddress);
  };
  const handleContactPersonInformation0 = (event) => {
    event.preventDefault();
    if (vendorInformation.country === "ECU") {
      if (event.target.name === "phone" && isNaN(event.target.value)) {
        setNonNumber(true);
      } else if (event.target.value.length <= 10) {
        contactPersonBank[event.target.name] = event.target.value;
        setNonNumber(false);
        sendContactPerson(contactPersonBank);
      } else {
        contactPersonBank[event.target.name] = event.target.value;
        setNonNumber(false);
        sendContactPerson(contactPersonBank);
      }
    } else {
      contactPersonBank[event.target.name] = event.target.value;
      setNonNumber(false);
      sendContactPerson(contactPersonBank);
    }
  };
  const submitForm = async (e) => {
    e.preventDefault();
    var ta = t("bankCertificate");
    if (vendorInformation.country === "ECU") {
      if (vendDocumentation.certificadO_BANCARIO === "") {
        alert("Error: missing " + ta);
      } else {
        vendBankAccount["namE_BANK"] =
          document.getElementById("namE_BANK").value;
        vendBankAccount["typE_ACCOUNT"] =
          document.getElementById("typE_ACCOUNT").value;
        vendBankAccount["identification"] = vendorInformation["ruc"];
        logisticsPostalAddress["province"] =
          document.getElementById("province").value;
        await Promise.all(
          [sendLogisticsPostalAddress(logisticsPostalAddress)],
          sendVendBankAccount(vendBankAccount)
        );
        if (vendFlowEnrollment.lasT_STEP === activeStep) {
          vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
          await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
        }
        handleNext();
      }
    }
    if (
      vendFlowEnrollment.lasT_STEP === activeStep &&
      vendorInformation.country !== "ECU"
    ) {
      vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
      await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
      handleNext();
    }
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getVendBankAccount()]);
      if (vendorInformation.country === "ECU") {
        await Promise.all([
          getListProvince(vendorInformation.country),
          getListBank(vendorInformation.company),
        ]);
      }
      setLoading(false);
    };
    fetchData2();
  }, []);

  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.country === "ECU") {
        await Promise.all([getListCity(logisticsPostalAddress.province)]);
      }
    };
    fetchData2();
  }, [logisticsPostalAddress.province]);

  if (isLoading) {
    return <Wait />;
  }
  return (
    <>
      <form
        onSubmit={(e) => {
          submitForm(e);
        }}
      >
        <Tittle>{t(steps[1])}</Tittle>
        <Container>
          <Column>
            <CssTextField
              type={"text"}
              value={vendBankAccount.namE_OWNER}
              required={true}
              fullWidth
              label={t("accountOwnerName")}
              id="namE_OWNER"
              name="namE_OWNER"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
          {vendorInformation.country === "ECU" && (
            <Column>
              <CssTextField
                type={"text"}
                required={true}
                // value={vendBankAccount.identification}
                value={vendorInformation.ruc}
                disabled
                fullWidth
                label={t("identityCard")}
                id="identification"
                name="identification"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          )}
          {vendorInformation.country !== "ECU" && (
            <Column>
              <CssTextField
                type={"text"}
                required={true}
                value={vendBankAccount.identification}
                fullWidth
                label={t("identityCard")}
                id="identification"
                name="identification"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          )}
          <Column>
            {vendorInformation.country === "ECU" ? (
              <FormControl required fullWidth>
                <InputLabel variant="standard">{t("bank")}</InputLabel>
                <CssNativeSelect
                  value={vendBankAccount.namE_BANK}
                  id="namE_BANK"
                  name="namE_BANK"
                  onChange={(e) => handleInformation(e)}
                >
                  {listBank.map((item) => (
                    <OptionSelect
                      key={item.bankGroupId}
                      value={item.bankGroupId}
                    >
                      {item.name}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            ) : (
              <CssTextField
                type={"text"}
                required={true}
                value={vendBankAccount.namE_BANK}
                fullWidth
                label={t("bank")}
                id="namE_BANK"
                name="namE_BANK"
                onChange={(e) => handleInformation(e)}
              />
            )}
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              required={true}
              value={vendBankAccount.nuM_ACCOUNT}
              fullWidth
              label={t("accountNum")}
              id="nuM_ACCOUNT"
              name="nuM_ACCOUNT"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
          {vendorInformation.country === "ECU" && (
            <Column>
              <FormControl required fullWidth>
                <InputLabel variant="standard">{t("accountType")}</InputLabel>
                <CssNativeSelect
                  value={vendBankAccount.typE_ACCOUNT}
                  id="typE_ACCOUNT"
                  name="typE_ACCOUNT"
                  onChange={(e) => handleInformation(e)}
                >
                  {typeAccount.map((item) => (
                    <OptionSelect key={item.id} value={item.id}>
                      {item.name}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
          )}
          {vendorInformation.country === "ECU" && (
            <Column>
              <CssTextField
                type={"text"}
                value={vendBankAccount.swifT_CODE}
                required={true}
                fullWidth
                label={t("swiftCode")}
                id="swifT_CODE"
                name="swifT_CODE"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          )}
          {vendorInformation.country !== "ECU" && (
            <Column>
              <CssTextField
                type={"text"}
                value={vendBankAccount.foreigN_SWIFT_CODE}
                required={true}
                fullWidth
                label={t("swiftCode")}
                id="foreigN_SWIFT_CODE"
                name="foreigN_SWIFT_CODE"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          )}
          <Column>
            <CssTextField
              type={"text"}
              value={logisticsPostalAddress.address}
              required={true}
              fullWidth
              label={t("address")}
              id="address"
              name="address"
              onChange={(e) => handleLogisticsAddressInformation(e)}
            />
          </Column>
          {vendorInformation.country === "ECU" && (
            <Column>
              <FormControl required fullWidth>
                <InputLabel>{t("province")}</InputLabel>
                <CssNativeSelect
                  value={logisticsPostalAddress.province}
                  id="province"
                  name="province"
                  onChange={(e) => handleLogisticsAddressInformation(e)}
                >
                  <OptionSelect></OptionSelect>
                  {listProvince.map((item) => (
                    <OptionSelect key={item.countyId} value={item.countyId}>
                      {item.name}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
          )}
          {vendorInformation.country === "ECU" ? (
            <Column>
              <FormControl required fullWidth>
                <InputLabel>{t("city")}</InputLabel>
                <CssNativeSelect
                  value={logisticsPostalAddress.city}
                  id="city"
                  name="city"
                  label={t("city") + " *"}
                  onChange={(e) => handleLogisticsAddressInformation(e)}
                >
                  <OptionSelect></OptionSelect>
                  {listCity.map((item) => (
                    <OptionSelect key={item.name} value={item.name}>
                      {item.description}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
          ) : (
            <Column>
              <CssTextField
                type={"text"}
                value={logisticsPostalAddress.city}
                required={true}
                fullWidth
                label={t("city")}
                id="city"
                name="city"
                onChange={(e) => handleLogisticsAddressInformation(e)}
              />
            </Column>
          )}
        </Container>
        <Tittle>{t("contactInfBankNotif")}</Tittle>
        <Container>
          <Column>
            <CssTextField
              type={"text"}
              value={
                listTypeContact.filter(
                  (x) => x.code === contactPersonBank.type
                )[0].description
              }
              required={true}
              fullWidth
              label={t("type")}
              id="type"
              name="type"
              disabled
              // onChange={(e) => handleContactPersonInformation0(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={contactPersonBank.name}
              required={true}
              fullWidth
              label={t("fullName")}
              id="name"
              name="name"
              onChange={(e) => handleContactPersonInformation0(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={contactPersonBank.identification}
              required={true}
              fullWidth
              label={t("identityCard")}
              id="identification"
              name="identification"
              onChange={(e) => handleContactPersonInformation0(e)}
            />
          </Column>
          <Column>
            <FormControl required fullWidth>
              <InputLabel variant="standard">
                {t("typeIdentification")}
              </InputLabel>
              <CssNativeSelect
                value={contactPersonBank.typE_IDENTIFICATION}
                id="typE_IDENTIFICATION"
                name="typE_IDENTIFICATION"
                onChange={(e) => handleContactPersonInformation0(e)}
              >
                {typeIdentification.map((item) => (
                  <OptionSelect key={item.id} value={item.id}>
                    {item.name}
                  </OptionSelect>
                ))}
              </CssNativeSelect>
            </FormControl>
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={contactPersonBank.position}
              required={true}
              fullWidth
              label={t("position")}
              id="position"
              name="position"
              onChange={(e) => handleContactPersonInformation0(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={contactPersonBank.area}
              required={true}
              fullWidth
              label={t("area")}
              id="area"
              name="area"
              onChange={(e) => handleContactPersonInformation0(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={contactPersonBank.phone}
              required={true}
              fullWidth
              label={t("phone")}
              id="phone"
              name="phone"
              onChange={(e) => handleContactPersonInformation0(e)}
            />
            {nonNumber && contactPersonBank.phone === "" && (
              <AlertSpan>
                <ErrorOutline /> {t("incorrectValue")}
              </AlertSpan>
            )}
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={contactPersonBank.email}
              required={true}
              fullWidth
              label={t("email")}
              id="email"
              name="email"
              onChange={(e) => handleContactPersonInformation0(e)}
            />
          </Column>
        </Container>

        {vendorInformation.country === "ECU" && (
          <>
            <Tittle>{t("documentation")}</Tittle>
            <Container>
              {documents.map((document, index) => {
                return (
                  <Column key={index}>
                    <ButtonUpload onClick={(e) => handleUpload(e, document.id)}>
                      {t(document.name)}
                      <UploadFileIcon />
                    </ButtonUpload>
                    <input
                      type="file"
                      accept="application/pdf"
                      name={"certificadO_BANCARIO"}
                      ref={document.id === 1 && uploadCertificadoBancario}
                      onChange={(e) => handleFileUpload(e)}
                      style={{ display: "none" }}
                    />
                  </Column>
                );
              })}
            </Container>
          </>
        )}
        <Container>
          <ColumnButtons>
            <Button onClick={handleBack}>{t("back")}</Button>
          </ColumnButtons>
          <ColumnButtons>
            <Button>{t("next")}</Button>
          </ColumnButtons>
        </Container>
      </form>
    </>
  );
};

export default Step2;
